/**
 * Product-template Tab & Accordion Functionality.
 *
 * Makes tabs selectable and accordion toggle-able.
 *
 * @since 2018-06-24
 * @see sections/product-template.liquid
 *
 */
export function initPDPTabs() {
  $('ul.tabs').each(function () {
    let activeLink, content;
    const links = $(this).find('a');
    activeLink = links.first();
    activeLink.parent().addClass('active');
    content = $(activeLink.attr('href'));

    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this)
      .find('a')
      .click(function () {
        activeLink.parent().removeClass('active');
        content.hide();
        activeLink = $(this);
        content = $($(this).attr('href'));
        activeLink.parent().addClass('active');
        content.show();
        return false;
      });
  });
}
